/**
 * AssumptionsBadge — muestra los supuestos de la IA que acompanan un modulo.
 *
 * Cada supuesto que la IA marco como inferencia (no dato duro del municipio)
 * se presenta como un chip ambar honesto: "Supuesto: <texto>. Verifica."
 * La transparencia sobre lo que NO es dato duro es un principio del diseno
 * del Asistente Formulador (trust > wow).
 *
 * Si la lista esta vacia, el componente no renderiza nada.
 */

interface AssumptionsBadgeProps {
  assumptions: string[];
}

/** Icono de alerta triangular en linea para chips ambar. */
function AlertIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="h-3.5 w-3.5 shrink-0"
    >
      <path
        fillRule="evenodd"
        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function AssumptionsBadge({ assumptions }: AssumptionsBadgeProps) {
  if (!assumptions || assumptions.length === 0) return null;

  return (
    <ul
      data-testid="assumptions-badge"
      className="mt-3 flex flex-col gap-2"
      aria-label="Supuestos de la IA que requieren verificación"
    >
      {assumptions.map((supuesto, idx) => (
        <li
          key={idx}
          className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800"
        >
          <span className="mt-0.5 text-amber-600">
            <AlertIcon />
          </span>
          <span>
            <strong>Supuesto:</strong> {supuesto} <span className="font-medium">Verifica.</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
